import React from 'react'
import styled from 'styled-components'
import Link from '../Link'
import LogoWord from '../../images/logo_word_refund.svg'

const Wrapper = styled.footer`
    display:flex;
    align-items:flex-start;
    justify-content:space-between;
    width:100%;
    padding: 25px 200px 50px 200px;
    background-color: #661271;

    max-width: 1500px;
    @media (max-width: 991px) {
        padding: 25px 50px;
        flex-direction: column;
    }
`
const LinkList = styled.div`
    display:flex;
    align-items: flex-start;
    justify-content:center;
    > ul {
    
        > p {
            color: white;
            font-size: 18px;
            font-family: Poppins;
            font-weight: 600;
            margin: 0 0 15px 0;
        }

        > li {
            list-style-type: none;
            > a {
                color: #F0A0FB;
                font-size: 16px;
                font-family: Poppins;
                font-weight: 500;
                line-height: 40px;
                text-decoration: none;

                &:hover {
                    color: #D521ED;
                    text-decoration: underline;
                }
            }
        }
    }
`; 
const Left = styled.ul`
    width: 150px;
`;
const Right = styled.ul`
    width: 150px;
`;
const Logo = styled.img``;

const Footer = () => {
  return (
    <Wrapper>
        <Logo src={LogoWord}/>
        <LinkList>

        <Left>
            <p>Company</p>            
            {/* <li><Link>Home</Link></li>
            <li><Link>Help Center</Link></li> */}
            <li><Link to='/terms-of-service/'>Terms&nbsp;&&nbsp;Conditions</Link></li>
            {/* <li><Link>Contact</Link></li> */}
            <li><Link to='/privacy-policy/'>Privacy</Link></li>
            <li><Link to='/learn/'>Learn</Link></li>
            </Left>
        <Right>
            {/* <p>Social</p>         
            <li><Link>Twitter</Link></li>
            <li><Link>LinkedIn</Link></li>
            <li><Link>YouTube</Link></li>
            <li><Link>TikTok</Link></li> */}

        </Right>

        </LinkList>
    </Wrapper>
  )
}

export default Footer